/*
 *  参数字段自定义规则验证
 *  xuzhongqi
 *  2020.12.29
 */
// 引入element
import {
	MessageBox,
	Message
} from 'element-ui'

// 基本信息表单验证
const informationForm = (obj) => {
	if (obj) {
		// 机构名称校验
		if (!obj.CustomerName || obj.CustomerName === '') {
			Message({
				message: '请输入机构名称' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		}
		// 客户类型校验
		if (!obj.CustomerType || obj.CustomerType === '') {
			Message({
				message: '请选择客户类型' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		} else {
			if (obj.CustomerType === 2) {
				// 如果客户类型为诊所，则校验是否选择经营性质
				if (obj.BusinessNature === '' || obj.BusinessNature === null) {
					Message({
						message: '请选择经营性质' || 'Warning',
						type: 'warning',
						duration: 2 * 1000,
					})
					return false
				}
			}
		}
		// 注册地址校验
		if (!obj.Address || obj.Address === '') {
			Message({
				message: '请输入注册地址' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		}
		// // 收货区域校验
		// if (!obj.AreaId || obj.AreaId === '') {
		// 	Message({
		// 		message: '请选择收货区域' || 'Warning',
		// 		type: 'warning',
		// 		duration: 2 * 1000
		// 	})
		// 	return false
		// }
		// // 详细地址校验
		// if (!obj.ReceivingAddressName || obj.ReceivingAddressName === '') {
		// 	Message({
		// 		message: '请输入详细地址' || 'Warning',
		// 		type: 'warning',
		// 		duration: 2 * 1000
		// 	})
		// 	return false
		// } else {
		// 	// 验证详细地址中是否包含省市区
		// 	const reg = /.+?(省|市|自治区|自治州|县|区)/g;
		// 	if (obj.ReceivingAddressName.match(reg) !== null) {
		// 		Message({
		// 			message: '详细地址中不能包含省市区' || 'Warning',
		// 			type: 'warning',
		// 			duration: 2 * 1000
		// 		})
		// 		return false
		// 	}
		// }
		// 联系人校验
		if (!obj.ContactsName || obj.ContactsName === '') {
			Message({
				message: '请输入联系人' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		} else {
			const patter = new RegExp('^[\u4E00-\u9FA5]{1,9}$')
			if (!patter.test(obj.ContactsName)) {
				Message({
					message: '请输入正确格式的姓名' || 'Error',
					type: 'error',
					duration: 2 * 1000,
				})
				return false
			}
		}
		// 联系电话校验
		if (!obj.Phone || obj.Phone === '') {
			Message({
				message: '请输入联系电话' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		} else {
			const patter = new RegExp(
				'^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$'
			)
			if (!patter.test(obj.Phone)) {
				Message({
					message: '请输入正确格式的手机号' || 'Error',
					type: 'error',
					duration: 2 * 1000,
				})
				return false
			}
		}
	}
	return obj
}

// 采购人员信息表单验证
const personnelForm = (obj) => {
	if (obj) {
		// 法人/委托人 人员类型
		if (!obj.type || obj.type === '') {
			Message({
				message: '请选择人员类型' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		} else {
			if (obj.ImgList.length === 0) {
				Message({
					message: '请上传人员类型必填资料' || 'Warning',
					type: 'warning',
					duration: 2 * 1000,
				})
				return false
			}
		}
		if (!obj.PersonName) {
			Message({
				message: '请填写姓名' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		}
		const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
		if (!reg.test(obj.IdCode)) {
			Message({
				message: '身份证号输入错误' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		}
	}
	return obj
}

// 第二类医疗器械经营备案凭证表单验证
const recordForm = (obj) => {
	if (obj) {
		// 是否有证
		if (!obj.type || obj.type === '') {
			Message({
				message: '请选择是否有第二类医疗器械经营备案凭证' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		} else {
			// 有
			if (obj.type === '1') {
				if (obj.ImgList.length === 0) {
					Message({
						message: '请上传第二类医疗器械经营备案凭证' || 'Warning',
						type: 'warning',
						duration: 2 * 1000,
					})
					return false
				}
				// 证件号
				if (!obj.No || obj.No === '') {
					Message({
						message: '请输入医疗器械证件号' || 'Warning',
						type: 'warning',
						duration: 2 * 1000,
					})
					return false
				}
				// 有效期
				if (!obj.Time || obj.Time === '') {
					Message({
						message: '请选择医疗器械经营备案凭证有效期' || 'Warning',
						type: 'warning',
						duration: 2 * 1000,
					})
					return false
				}
			}
		}
	}
	return obj
}

// 食品经营许可证提交表单验证
const foodForm = (obj) => {
	if (obj) {
		// 是否有证
		if (!obj.type || obj.type === '') {
			Message({
				message: '请选择是否有食品经营许可证' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		} else {
			// 有
			if (obj.type === '1') {
				if (obj.ImgList.length === 0) {
					Message({
						message: '请上传食品经营许可证' || 'Warning',
						type: 'warning',
						duration: 2 * 1000,
					})
					return false
				}
				// 证件号
				if (!obj.No || obj.No === '') {
					Message({
						message: '请输入食品经营许可证证件号' || 'Warning',
						type: 'warning',
						duration: 2 * 1000,
					})
					return false
				}
				// 有效期
				if (!obj.Time || obj.Time === '') {
					Message({
						message: '请选择食品经营许可证有效期' || 'Warning',
						type: 'warning',
						duration: 2 * 1000,
					})
					return false
				}
			}
		}
	}
	return obj
}

// 营业执照表单验证
const licenseForm = (obj) => {
	if (obj) {
		// 是否有证
		if (!obj.type || obj.type === '') {
			Message({
				message: '请选择是否有营业执照' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		} else {
			// 有
			if (obj.ImgList.length === 0) {
				Message({
					message: '请上营业执照必填资料' || 'Warning',
					type: 'warning',
					duration: 2 * 1000,
				})
				return false
			}
			// 证件号
			if (!obj.No || obj.No === '') {
				Message({
					message: '请输入营业执照证件号' || 'Warning',
					type: 'warning',
					duration: 2 * 1000,
				})
				return false
			}
			// 有效期
			if (!obj.Time || obj.Time === '') {
				Message({
					message: '请选择营业执照有效期' || 'Warning',
					type: 'warning',
					duration: 2 * 1000,
				})
				return false
			}
		}
	}
	return obj
}

// 医疗机构执业许可证表单验证
const institutionForm = (obj) => {
	if (obj) {
		// 图片
		if (obj.ImgList.length === 0) {
			Message({
				message: '请上传医疗机构执业许可证资料' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		}
		// 证件号
		if (!obj.No || obj.No === '') {
			Message({
				message: '请输入医疗机构执业许可证件号' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		}
		// 有效期
		if (!obj.Time || obj.Time === '') {
			Message({
				message: '请选择医疗机构执业许可证有效期' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		}
	}
	return obj
}

// 药品经营许可证表单验证
const businessLicenseForm = (obj) => {
	if (obj) {
		// 判断是否选择二证合一
		if (!obj.type || obj.type === '') {
			Message({
				message: '请选择是否二证合一' || 'Warning',
				type: 'warning',
				duration: 2 * 1000,
			})
			return false
		} else {
			// 图片
			if (obj.ImgList.length === 0) {
				Message({
					message: '请上传必填资料' || 'Warning',
					type: 'warning',
					duration: 2 * 1000,
				})
				return false
			}
			// 证件号
			if (!obj.No || obj.No === '') {
				Message({
					message: '请输入证件号' || 'Warning',
					type: 'warning',
					duration: 2 * 1000,
				})
				return false
			}
			// 有效期
			if (!obj.Time || obj.Time === '') {
				Message({
					message: '请选择有效期' || 'Warning',
					type: 'warning',
					duration: 2 * 1000,
				})
				return false
			}
			// 判断是否二证合一
			// 非二证合一
			if (obj.type === '2') {
				// 判断是否选择GSP类型
				if (!obj.gpsType || obj.gpsType === '') {
					Message({
						message: '请选择GSP证数类型' || 'Warning',
						type: 'warning',
						duration: 2 * 1000,
					})
					return false
				} else {
					// 图片
					if (obj.gpsImgList.length === 0) {
						Message({
							message: '请上传GSP必填资料' || 'Warning',
							type: 'warning',
							duration: 2 * 1000,
						})
						return false
					}
					// 判断GPS资料是否缺失
					if (obj.gpsType === '1') {
						// 证件号
						if (!obj.gpsNo || obj.gpsNo === '') {
							Message({
								message: '请输入GSP证件号' || 'Warning',
								type: 'warning',
								duration: 2 * 1000,
							})
							return false
						}
						// 有效期
						if (!obj.gpsTime || obj.gpsTime === '') {
							Message({
								message: '请选择GSP有效期' || 'Warning',
								type: 'warning',
								duration: 2 * 1000,
							})
							return false
						}
					}
				}
			}
		}
	}
	return obj
}

export default {
	informationForm: informationForm,
	personnelForm: personnelForm,
	recordForm: recordForm,
	foodForm: foodForm,
	licenseForm: licenseForm,
	institutionForm: institutionForm,
	businessLicenseForm: businessLicenseForm,
}
